import React from 'react'
import fetcher from "../../../fetcher";
import {useFetchResource} from "../../../hooks/useFetchResource";
import {CRMListDealCard} from "./CRMListDealCard";

export const MiniDealCard = ({ dealId, defaultChecked, toggleSelected }) => {
    const [dealState, setDealState] = useFetchResource(fetcher.getDeal, dealId)

    if (!dealState) return null;

    return <CRMListDealCard deal={dealState} defaultChecked={defaultChecked} toggleSelected={toggleSelected}/>

}